import { abyssColors } from '@/theme/colors';

export const tabIndicatorStyle = {
  backgroundColor: abyssColors.secondary[500],
  height: 3,
  borderRadius: 2,
};

export const tabStyle = {
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '1.4rem',
  color: abyssColors.primary[400],
  '&.Mui-selected': {
    color: abyssColors.primary[500],
  },
};

export const pointOfInterestTabsStyles = {
  '&.MuiTabs-root': {
    minHeight: 'fit-content',
    marginBottom: '0.8rem',
  },
  '& .MuiTab-root': {
    minWidth: 0,
    minHeight: 'fit-content',
    textTransform: 'none',
    border: 'none',
    padding: '0.4rem 1.6rem',
  },
  '& .MuiTab-root.Mui-selected': {
    backgroundColor: `${abyssColors.primary[100]} !important`,
    borderRadius: '4px',
  },
  '& .MuiTabs-indicator': {
    height: '0rem',
    border: 'none',
  },
};

export const feedbackContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  py: 7,
};
